import { Accordion, AccordionItem } from '@/molecules/Accordion'
import { IFaqSectionFields } from '@/types/generated-contentful'
import TextBlock from './TextBlock'

const FAQ: React.FC<IFaqSectionFields> = ({ faqs }) => {
  if (faqs && faqs.length === 0) {
    return null
  }

  return (
    <Accordion>
      {faqs.map((item) => {
        const { answer, question } = item.fields
        return (
          <AccordionItem
            key={item.sys.id}
            labelClassName="photon-paragraph-md text-core-gray-900 text-bold"
            label={question}
            iconColor="core-gray-900"
            borderColor="core-gray-300"
            rowClassName="border-none"
            showBottomBorder
          >
            <TextBlock document={answer} />
          </AccordionItem>
        )
      })}
    </Accordion>
  )
}

export default FAQ
